import { useEffect, useRef, useState } from "react";
import { Toast } from "antd-mobile";
import axios from "axios";
import { useLocation } from "react-router-dom";

import iosButton from "../../assets/images/new-ios.png";
import androidButton from "../../assets/images/new-az.png";
import webButton from "../../assets/images/new-web.png";
import khButton from "../../assets/images/new-kh.png";

import Container from "../../components/Container";

const node_env = process.env.NODE_ENV || "development";

interface DownloadConfig {
  ios_url: string;
  android_url: string;
  h5_url: string;
  kefu_url: string;
}

const DEFAULT_URL = "https://your-default-url.com"; // 兜底地址

const NewRegisteredSuccess = () => {
  const downloadUrls = useRef<DownloadConfig>({
    ios_url: "",
    android_url: "",
    h5_url: "",
    kefu_url: "",
  });

  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const { name, password } = location.state || {};

  // 随机选取一个包（与RegisteredSuccess.tsx保持一致）
  const getRandomItem = (arr: any[]) => {
    if (!Array.isArray(arr) || arr.length === 0) return "";
    return arr[Math.floor(Math.random() * arr.length)];
  };

  // 拉取分发包下载地址，与RegisteredSuccess.tsx保持一致
  const fetchDownloadUrls = async () => {
    try {
      const random = Math.floor(Math.random() * 90) + 10;

      const res = await axios.get(`/downloadConfig.json?${random}`);
      const urlList = res.data?.[node_env] || [];

      for (const url of urlList) {
        try {
          const result = await axios.get(`${url}?${random}`);
          const { h5_package, ios_package, android_package, kefu } = result.data || {};

          // 一旦拿到有效数据就停止
          const ios = getRandomItem(ios_package);
          const android = getRandomItem(android_package);
          const h5 = getRandomItem(h5_package);
          const kefu_url = getRandomItem(kefu);
          if (ios || android || h5 || kefu_url) {
            downloadUrls.current = {
              ios_url: ios || DEFAULT_URL,
              android_url: android || DEFAULT_URL,
              h5_url: h5 || DEFAULT_URL,
              kefu_url: kefu_url || DEFAULT_URL,
            };
            break;
          }
        } catch (err) {
          console.log("子接口失败:", err);
        }
      }
    } catch (err) {
      console.log("主接口失败:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDownloadUrls();
    // eslint-disable-next-line
  }, []);

  // 加密，把明文变为base64字符串，与RegisteredSuccess.tsx一致
  const encrypt = (str: string) => {
    if (!str) return "";
    return btoa(str);
  };

  // 统一跳转逻辑，与RegisteredSuccess.tsx一致
  const safeJump = (url: string) => {
    if (!url) {
      Toast.show("下载地址还在加载中...");
      return;
    }
    window.location.href = url;
  };

  const gotoIos = () => {
    safeJump(downloadUrls.current.ios_url);
  };

  const gotoAndroid = () => {
    safeJump(downloadUrls.current.android_url);
  };

  const gotoH5 = () => {
    const baseUrl = downloadUrls.current.h5_url;
    if (!baseUrl) {
      Toast.show("地址未准备好");
      return;
    }
    const url = `${baseUrl}?name=${encodeURIComponent(
      encrypt(name)
    )}&paw=${encodeURIComponent(encrypt(password))}`;
    window.location.href = url;
  };

  // 联系客服，和RegisteredSuccess.tsx一致-功能未实现
  const gotoKH = () => {
    const baseUrl = downloadUrls.current.kefu_url;
    debugger;
    if (!baseUrl) {
      Toast.show("地址未准备好");
      return;
    }
    const url = `${baseUrl}?cert=CCMQBRgBILkBKJOUstaoMg.TplldFOt8kL38C0c2LMEqRgTAVHnVrZ7RJGCP1Edk1glgMuPoQfE_xo2Ei-iC9k7GPBvBwxHZ4qEjZe7JX3YDg&pty=qlfUuCMtQVg3CLrsjePP&custom={%22hash%22:%22fhkj123%22,%22id%22:5}`;
    window.location.href = url;
  };

  // =======================
  // 背景图要全部展示出来（需覆盖整个可视高度，底部无遗漏），按钮居下
  // =======================
  return (
    <Container
      style={{
        background: `#000 url(${require("../../assets/images/new-down.png")}) no-repeat center center`,
        backgroundSize: "100% 100%",
        minHeight: "100vh",
        height: "100vh",
        width: "100vw",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: "7vh", // 调高按钮区到底部的间距，使底部内容不被遮挡
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pointerEvents: "auto",
          zIndex: 10,
        }}
      >
        <div
          className="flex flex-col gap-[14px] w-full max-w-[400px]"
          style={{
            width: "90%",
            margin: "0 auto",
          }}
        >
          <div className="flex flex-row w-full gap-[10px]">
            <button
              disabled={loading}
              onClick={gotoIos}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                outline: "none",
                padding: 0,
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(255, 255, 255, 0.07)",
              }}
            >
              <img
                src={iosButton}
                alt="iOS"
                style={{
                  width: "100%",
                  maxWidth: 198,
                  display: "block",
                  height: "47px",
                  objectFit: "cover",
                  opacity: loading ? 0.7 : 1,
                  pointerEvents: loading ? "none" : "auto",
                }}
                draggable={false}
              />
            </button>
            <button
              disabled={loading}
              onClick={gotoAndroid}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                outline: "none",
                padding: 0,
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(255,255,255,0.07)",
              }}
            >
              <img
                src={androidButton}
                alt="Android"
                style={{
                  width: "100%",
                  maxWidth: 198,
                  display: "block",
                  height: "47px",
                  objectFit: "cover",
                  opacity: loading ? 0.7 : 1,
                  pointerEvents: loading ? "none" : "auto",
                }}
                draggable={false}
              />
            </button>
          </div>
          <div className="flex flex-row w-full gap-[10px] ">
            <button
              disabled={loading}
              onClick={gotoH5}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                outline: "none",
                padding: 0,
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(255,255,255,0.07)",
              }}
            >
              <img
                src={webButton}
                alt="Web"
                style={{
                  width: "100%",
                  maxWidth: 198,
                  display: "block",
                  height: "47px",
                  objectFit: "cover",
                  opacity: loading ? 0.7 : 1,
                  pointerEvents: loading ? "none" : "auto",
                }}
                draggable={false}
              />
            </button>
            <button
              disabled={loading}
              onClick={gotoKH}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                outline: "none",
                padding: 0,
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(255,255,255,0.07)",
              }}
            >
              <img
                src={khButton}
                alt="客服"
                style={{
                  width: "100%",
                  maxWidth: 198,
                  display: "block",
                  height: "47px",
                  objectFit: "cover",
                  opacity: loading ? 0.7 : 1,
                  pointerEvents: loading ? "none" : "auto",
                }}
                draggable={false}
              />
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NewRegisteredSuccess;